import { Component, OnInit, Inject, HostBinding, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AttributeType } from 'src/shared/enums';
import { ZoningCodeAttribute } from '../../../models';
import { UntypedFormBuilder } from '@angular/forms';

import * as _ from 'lodash';
import { AttributesPopupComponent } from './attributes-popup.component';
import { ZoningCodeAttributeService } from '../../../core/services';
import { MatDialogRef } from '@angular/material/dialog';
import { IAttributePopupParams } from 'src/app/interfaces/attribute-popup-params.interface';

@Component({
    standalone: false,
    selector: 'zoning-code-attributes-popup',
    templateUrl: './attributes-popup.component.html',
    styleUrls: ['./attributes-popup.component.scss'],
    encapsulation: ViewEncapsulation.None

})
export class ZoningCodeAttributesPopupComponent extends AttributesPopupComponent implements OnInit {

    @HostBinding('class')
    readonly hostClass = 'attributes-popup';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IAttributePopupParams,
        protected readonly attributeService: ZoningCodeAttributeService,
        protected readonly formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<ZoningCodeAttributesPopupComponent>,
    ) {
        super(data, formBuilder);
    }

    ngOnInit() {
        super.ngOnInit();
        this.attributeService.getAttributesForZoningCodeField(this.tableFieldId, this.tableType)
            .subscribe(attributes => this.initAttributes(attributes));
    }

    private get tableFieldId() {
        return _.get(this.data, 'parameters.TableFieldId');
    }

    private get tableType() {
        return _.get(this.data, 'parameters.TableType');
    }

    addNewLink() {
        if (this.linkForm.invalid) {
            return;
        }

        const newLink = new ZoningCodeAttribute({
            TableFieldId: this.tableFieldId,
            AttributeType: AttributeType.LINK,
            TableType: this.tableType,
            AttributeValue: this.linkForm.value.linkValue,
            Description: this.linkForm.value.linkDescription,
        });

        super.addNewLink(newLink);
    }

    async save() {
        await super.save();

        const queries = this.getAttributeOperationsObservables();

        this.callForkJoin(queries);

        this.dialogRef.close();
    }

    initDefaultAssumption() {
        if (!this.assumptionsValue.length) {
            this.setAssumptions(this.assumptionsValue.concat(new ZoningCodeAttribute({
                TableFieldId: this.tableFieldId,
                TableType: this.tableType,
                AttributeType: AttributeType.ASSUMPTION,
                AttributeValue: '',
                IsEnabled: false
            })));
        }
    }

    initDefaultComment() {
        if (!this.commentsValue.length) {
            this.setComments(this.commentsValue.concat(new ZoningCodeAttribute({
                TableFieldId: this.tableFieldId,
                TableType: this.tableType,
                AttributeType: AttributeType.COMMENT,
                AttributeValue: '',
            })));
        }
    }
}
